<template>
  <div class="flex justify-center items-center h-screen bg-gradient-to-br from-blue-900 to-cyan-600">
    <div class="w-96 p-10 bg-white rounded-lg shadow-xl">
      <div class="text-center mb-8">
        <img src="../assets/logo.png" alt="Logo" class="w-20 h-20 mx-auto mb-4">
        <h2 class="text-2xl font-medium text-gray-800">系统登录</h2>
      </div>
      
      <el-form :model="loginForm" :rules="loginRules" ref="loginForm" class="space-y-6">
        <el-form-item prop="username">
          <el-input 
            v-model="loginForm.username" 
            prefix-icon="el-icon-user" 
            placeholder="请输入用户名"
            clearable>
          </el-input>
        </el-form-item>
        <el-form-item prop="password">
          <el-input 
            v-model="loginForm.password" 
            prefix-icon="el-icon-lock" 
            placeholder="请输入密码" 
            type="password"
            show-password
            @keyup.enter.native="handleLogin">
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-button 
            type="primary" 
            class="w-full py-3" 
            :loading="loading" 
            @click="handleLogin">
            登录
          </el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import { login } from '@/api/auth'
import { encryptPassword } from '@/utils/password'
import signalRIdentityManager from '@/utils/signalr-identity-manager'

export default {
  name: 'UserLogin',
  data() {
    return {
      loginForm: {
        username: '',
        password: ''
      },
      loginRules: {
        username: [
          { required: true, message: '请输入用户名', trigger: 'blur' },
          { min: 3, max: 20, message: '用户名长度在3到20个字符之间', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { min: 6, max: 20, message: '密码长度必须在6到20个字符之间', trigger: 'blur' }
        ]
      },
      loading: false,
      redirect: undefined
    }
  },
  created() {
    // 获取重定向地址
    this.redirect = this.$route.query.redirect
    
    // 检查是否已登录，如果已登录则跳转到首页
    const token = localStorage.getItem('token')
    if (token) {
      this.$router.push(this.redirect || '/')
    }
  },
  methods: {
    handleLogin() {
      this.$refs.loginForm.validate(async valid => {
        if (valid) {
          // 额外校验密码长度
          if (this.loginForm.password.length < 6 || this.loginForm.password.length > 20) {
            this.$message.error('密码长度必须在6到20个字符之间');
            return;
          }
          
          this.loading = true
          try {
            // 使用密码加密
            const originalPassword = this.loginForm.password
            const encryptedPassword = encryptPassword(originalPassword)
            
            const response = await login({
              username: this.loginForm.username,
              password: encryptedPassword // 使用加密后的密码
            })
            
            // 检查返回的格式是否正确
            if (response.code === 200 && response.data && response.data.token) {
              // 保存token到localStorage
              localStorage.setItem('token', response.data.token)
              // 保存用户信息
              if (response.data.username) {
                localStorage.setItem('username', response.data.username)
              }
              if (response.data.userId) {
                localStorage.setItem('userId', response.data.userId)
              }
              
              // // 使用身份管理器处理登录后的SignalR身份信息
              // await signalRIdentityManager.handleLogin({
              //   userId: response.data.userId,
              //   username: response.data.username,
              //   realName: response.data.realName,
              //   roles: response.data.roles
              // }, this.$signalR)
              
              this.$message({
                message: '登录成功',
                type: 'success'
              })
              
              // 登录成功，重定向到首页
              this.$router.push(this.redirect || '/')
            } else {
              throw new Error(response.message || '登录失败')
            }
          } catch (error) {
            console.error(error)
            this.$message({
              message: error.message || '登录失败，请检查用户名和密码',
              type: 'error'
            })
          } finally {
            this.loading = false
          }
        }
      })
    }
  }
}
</script>

<style scoped>
/* All styles have been moved to Tailwind classes */
</style> 